import { z } from 'zod';

/**
 * The headers that select the brand and application a request is made in. They only select a scope: the server
 * verifies the user has that application through that brand. Shared so every sender and reader (the chat client,
 * chat-api, and management-api forwarding for the page builder) agrees on the names and the identifier shape.
 */
export const BRAND_IDENTIFIER_HEADER = 'X-Brand-Identifier';
export const APPLICATION_IDENTIFIER_HEADER = 'X-Application-Identifier';

/** Identifiers are opaque tokens (uuids, hex strings, slugs). Anything else is not one. */
export const AccessScopeIdentifierSchema = z
  .string()
  .trim()
  .min(1)
  .max(128)
  .regex(/^[A-Za-z0-9_-]+$/);
